export const DOTS = '...'
